document.addEventListener("DOMContentLoaded", function () {
    let customButton = document.getElementById("customAddToCart");
    let form = document.querySelector('form[action="/cart/add"]');

    if (customButton && form) {
        customButton.addEventListener("click", function () {
            form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        });
    }

    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
        form.addEventListener("submit", function (event) {
            event.preventDefault(); // Mencegah submit form default

            let formData = new FormData(form);
            let variantIDKeyboard = formData.get("id") || document.querySelector('[name="id"]').value;

            let switchChoice = document.querySelector('input[name="properties[Switch]"]:checked');
            if (!switchChoice) {
                alert("Pastikan Switch sudah dipilih!");
                return;
            }

            let switchVariant = switchChoice.value;

            // Mapping switch ke variantID (gunakan nilai yang dipilih)
            let switchVariantMapping = {
                "Switch Stock": "48249616892182",
                "Switch Ivory Linear": "48249616892173",
                "Switch Salmon Tactile": "48249260081430",
                "Switch Jupiter Tactile": "47382013346070",
                "Switch Neptune Linear": "47382026813718",
                "Switch Vaporwave Tactile": "47382303834390",
                "Switch Pressplay x Crankytech Azurite Linear": "47382382149910"
            };

            let switchVariantID = switchVariantMapping[switchVariant];

            // Pastikan ada variantID switch yang cocok
            if (!switchVariantID) {
                alert("Switch yang dipilih tidak valid!");
                return;
            }

            // Composite mapping: variantKeyboard + '|' + switchChoice
             let skuMapping = {
  "50001884119318|Switch Stock": [
    
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884119318|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884119318|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884119318|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884119318|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884119318|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884119318|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120231190|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120329494|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "48870842630422", // Cosmonaut
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119837974|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382196519190",  // Harajuku
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50001884184854|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120034582|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50007537877270|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "49863916749078", // PPBT Rover
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726119936278|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120427798|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "49726120132886|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382394437910", // PPBT Ube
    "48204448170262" // Apollo 61 Lite Smokey Black
  ],
  "50005122941206|Switch Stock": [
    
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122941206|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122941206|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122941206|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122941206|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122941206|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122941206|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123105046|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123137814|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "48870842630422", // Cosmonaut
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005122973974|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382196519190",  // Harajuku
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123203350|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123039510|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50007537910038|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "49863916749078", // PPBT Rover
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123006742|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123170582|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Ivory Linear": [
    "50017738326294", // Switch Ivory
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Jupiter Tactile": [
    "50020280795414", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Neptune Linear": [
    "50020239507734", // Switch Neptune
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Vaporwave Tactile": [
    "50020026188054", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50005123072278|Switch Pressplay x Crankytech Azurite Linear": [
    "50019939942678", // Switch Azurite
    "47382394437910", // PPBT Ube
    "48204448235798" // Apollo61 Clear White
  ],
  "50001884971286|Switch Stock": [
    
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001884971286|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001884971286|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001884971286|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001884971286|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001884971286|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001884971286|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885298966|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885364502|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "48870842630422", // Cosmonaut
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885036822|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382196519190",  // Harajuku
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885495574|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885167894|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50007538073878|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49863916749078", // PPBT Rover
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885102358|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885430038|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50001885233430|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382394437910", // PPBT Ube
    "49538898264342" // Rover84 Lightyear Stardust White
  ],
  "50005123825942|Switch Stock": [
    
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123825942|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123825942|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123825942|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123825942|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123825942|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123825942|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123989782|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124022550|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "48870842630422", // Cosmonaut
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123858710|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382196519190",  // Harajuku
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124088086|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123924246|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50007538106646|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49863916749078", // PPBT Rover
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123891478|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005124055318|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123957014|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382394437910", // PPBT Ube
    "49538898297110" // Rover84 Lightyear Void Black
  ],
  "50005123531030|Switch Stock": [
    
    
    "47382428352790" // Rover84 Red
  ],
  "50005123531030|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    
    "47382428352790" // Rover84 Red
  ],
  "50005123531030|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "47382428352790" // Rover84 Red
  ],
  "50005123531030|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    
    "47382428352790" // Rover84 Red
  ],
  "50005123531030|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    
    "47382428352790" // Rover84 Red
  ],
  "50005123531030|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    
    "47382428352790" // Rover84 Red
  ],
  "50005123531030|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123694870|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123727638|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "48870842630422", // Cosmonaut
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123563798|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382196519190",  // Harajuku
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123793174|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50005123629334|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50007538041110|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49863916749078", // PPBT Rover
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123596566|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123760406|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50005123662102|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382394437910", // PPBT Ube
    "47382428352790" // Rover84 Red
  ],
  "50001884381462|Switch Stock": [
    
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884381462|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884381462|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884381462|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884381462|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884381462|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884381462|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884709142|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884774678|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "48870842630422", // Cosmonaut
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884446998|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382196519190",  // Harajuku
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884905750|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884578070|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50007538008342|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "49863916749078", // PPBT Rover
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884512534|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884840214|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Ivory Linear": [
    "50017738391830", // Switch Ivory
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Salmon Tactile": [
    "50019896721686", // Switch Salmon
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Jupiter Tactile": [
    "50020280860950", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Neptune Linear": [
    "50020239573270", // Switch Neptune
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Vaporwave Tactile": [
    "50020026253590", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884643606|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940008214", // Switch Azurite
    "47382394437910", // PPBT Ube
    "47382428418326" // ROVER84 v4 Smokey Black
  ],
  "50001884250390|Switch Stock": [
    
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884250390|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884250390|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884250390|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884250390|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884250390|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884250390|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120919318|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121017622|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "48870842630422", // Cosmonaut
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120526102|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382196519190",  // Harajuku
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50001884315926|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120722710|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50007537942806|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "49863916749078", // PPBT Rover
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120624406|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726121115926|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "49726120821014|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382394437910", // PPBT Ube
    "47382211166486" // VOYAGER68 v2 Milky Purple
  ],
  "50005123236118|Switch Stock": [
    
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123236118|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123236118|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123236118|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123236118|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123236118|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123236118|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123399958|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123432726|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "48870842630422", // Cosmonaut
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123268886|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382196519190",  // Harajuku
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123498262|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123334422|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50007537975574|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "49863916749078", // PPBT Rover
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123301654|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123465494|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Ivory Linear": [
    "50017738424598", // Switch Ivory
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Salmon Tactile": [
    "50019896754454", // Switch Salmon
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Jupiter Tactile": [
    "50020280893718", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Neptune Linear": [
    "50020239606038", // Switch Neptune
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Vaporwave Tactile": [
    "50020026286358", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  "50005123367190|Switch Pressplay x Crankytech Azurite Linear": [
    "50019940040982", // Switch Azurite
    "47382394437910", // PPBT Ube
    "47382210969878" //  VOYAGER68 v2 Smokey Black
  ],
  
  "50134567125270|Switch Stock": [
    
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567125270|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567125270|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567125270|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567125270|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567125270|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567125270|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567289110|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567321878|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "48870842630422", // Cosmonaut
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567158038|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382196519190",  // Harajuku
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567387414|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567223574|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567420182|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "49863916749078", // PPBT Rover
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567190806|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567354646|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Salmon Tactile": [
    "50134871736598", // Switch Salmon
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  "50134567256342|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382394437910", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Smokey Black
  ],
  
  "50134567452950|Switch Stock": [
    
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567452950|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567452950|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567452950|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567452950|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567452950|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567452950|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567616790|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567649558|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "48870842630422", // Cosmonaut
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567485718|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382196519190",  // Harajuku
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567715094|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567223574|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567747862|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "49863916749078", // PPBT Rover
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567518486|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567682326|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50134567584022|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382394437910", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White
  ],

  ///Penambahan Baru - 21-11-25 // 
  
  "50754486075670|Switch Stock": [
    
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486075670|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486075670|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486075670|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486075670|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486075670|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486075670|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Stock": [
    
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486239510|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "49149984964886",  // PPBT Brighton
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Stock": [
    
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486272278|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "48870842630422", // Cosmonaut
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Stock": [
    
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486108438|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382196519190",  // Harajuku
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Stock": [
    
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486337814|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382379299094",  // Korean Vintage
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Stock": [
    
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567223574|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382389358870", // PPBT Matcha
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Stock": [
    
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486370582|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "49863916749078", // PPBT Rover
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Stock": [
    
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486141206|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382198550806", // PPBT Shibuya
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Stock": [
    
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50134567682326|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382220636438", // PPBT Shirakawa,
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Stock": [
    
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],
  "50754486206742|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "47382394437910", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear White Wireless
  ],

  "50754609152278|Switch Stock": [
    
    "50484871463190", // PPBT RES
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754609152278|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50484871463190", // PPBT RES
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754609152278|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50484871463190", // PPBT RES
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754609152278|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50484871463190", // PPBT RES
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754609152278|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50484871463190", // PPBT RES
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754609152278|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50484871463190", // PPBT Ube
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754609152278|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50484871463190", // PPBT RES
    "50133084504342" // ESSENTIAL75 Clear Black
  ],

  "50754609185046|Switch Stock": [
    
    "50484871463190", // PPBT RES
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754609185046|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50484871463190", // PPBT RES
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754609185046|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50484871463190", // PPBT RES
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754609185046|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50484871463190", // PPBT RES
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754609185046|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50484871463190", // PPBT RES
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754609185046|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50484871463190", // PPBT Ube
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754609185046|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50484871463190", // PPBT RES
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754609217814|Switch Stock": [
    
    "50484871463190", // PPBT RES
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754609217814|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50484871463190", // PPBT RES
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754609217814|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50484871463190", // PPBT RES
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754609217814|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50484871463190", // PPBT RES
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754609217814|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50484871463190", // PPBT RES
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754609217814|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50484871463190", // PPBT Ube
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754609217814|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50484871463190", // PPBT RES
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754664268054|Switch Stock": [
    
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754664268054|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754664268054|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754664268054|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754664268054|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754664268054|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754664268054|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50741895168278", // PPBT Giyu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754664300822|Switch Stock": [
    
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754664300822|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754664300822|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754664300822|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754664300822|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754664300822|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754664300822|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50741895168278", // PPBT Giyu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754664333590|Switch Stock": [
    
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754664333590|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754664333590|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754664333590|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754664333590|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754664333590|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754664333590|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50741895168278", // PPBT Giyu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754703786262|Switch Stock": [
    
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754703786262|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754703786262|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754703786262|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754703786262|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754703786262|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black 
  ],
  "50754703786262|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50741905031446", // PPBT Shinobu
    "50133084504342" // ESSENTIAL75 Clear Black
  ],
  "50754703819030|Switch Stock": [
    
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754703819030|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754703819030|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754703819030|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754703819030|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
  "50754703819030|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White 
  ],
  "50754703819030|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50741905031446", // PPBT Shinobu
    "50133084537110" // ESSENTIAL75 Clear White
  ],
   "50754703851798|Switch Stock": [
    
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754703851798|Switch Ivory Linear": [
    "50134868623638", // Switch Ivory
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754703851798|Switch Salmon Tactile": [
    "50019896656150", // Switch Salmon
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754703851798|Switch Jupiter Tactile": [
    "50134876061974", // Switch Jupiter
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754703851798|Switch Neptune Linear": [
    "50134874849558", // Switch Neptune
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ],
  "50754703851798|Switch Vaporwave Tactile": [
    "50134874063126", // Switch Vaporwave
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless 
  ],
  "50754703851798|Switch Pressplay x Crankytech Azurite Linear": [
    "50134872949014", // Switch Azurite
    "50741905031446", // PPBT Shinobu
    "50535780811030" // ESSENTIAL75 Clear Wireless
  ]
};

            // Membuat key kombinasi variantID dan switchChoice
            let compositeKey = variantIDKeyboard + "|" + switchVariant;

            let skusToAdd = skuMapping[compositeKey] || [];
            if (skusToAdd.length === 0) {
                alert("Pastikan kombinasi varian dan switch sudah dipilih dengan benar!");
                return;
            }

            let cartItems = skusToAdd.map(sku => ({ id: sku, quantity: 1 }));

            fetch('/cart/add.js', {
                method: 'POST',
                body: JSON.stringify({ items: cartItems }),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json())
            .then(data => {
                console.log("Success:", data);
                window.location.href = '/cart';
            })
            .catch(error => console.error("Error:", error));
        });
    });

    let firstVariant = document.querySelector('[name="id"]');
    if (firstVariant) {
        let variantID = firstVariant.value;
        let url = new URL(window.location.href);
        if (!url.searchParams.get("variant")) {
            url.searchParams.set("variant", variantID);
            window.history.replaceState({}, '', url);
        }
    }
});